import React from "react";

const PDFDownloadIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="currentColor"
      strokeWidth="1.5"
    >
      <path d="M10 4V12M10 12L7 9M10 12L13 9M4 16H16" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default PDFDownloadIcon;
